import { useQuery } from 'react-query'

import type { AccountsService } from 'features/accounts/service'
import type { AccountGroup } from 'features/accounts/types'

export const ACCOUNT_GROUPS_QUERY_KEY = 'account-groups'

type UseAccountGroupsResult = {
  accountGroups: AccountGroup[]
  isLoading: boolean
}

export function useAccountGroups(
  service: AccountsService,
  enabled: boolean,
): UseAccountGroupsResult {
  const { data, isLoading } = useQuery<AccountGroup[]>(
    [ACCOUNT_GROUPS_QUERY_KEY],
    () => service.listAccountGroups(),
    { enabled, refetchOnWindowFocus: false },
  )
  return { accountGroups: data ?? [], isLoading }
}
